import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-695b2f6a"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loginTips hide"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi"
}), /*#__PURE__*/_createElementVNode("span", {
  id: "error_info"
})], -1));

const _hoisted_2 = {
  class: "login lg"
};
const _hoisted_3 = {
  class: "login-top"
};
const _hoisted_4 = {
  class: "login-form-p"
};
const _hoisted_5 = {
  class: "lg-div"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_7 = {
  class: "login-form-p"
};
const _hoisted_8 = {
  class: "lg-div"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_10 = {
  class: "login-form-p"
};
const _hoisted_11 = {
  class: "lg-div"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "know-protocol"
};
const _hoisted_14 = {
  class: "text"
};
const _hoisted_15 = {
  class: "login-footer"
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_17 = {
  href: "/password/send"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "forgot-pass-01",
  style: {
    "margin-left": "23px"
  }
}, null, -1));

const _hoisted_19 = {
  class: "loginSuccess hide"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconyuanxingxuanzhongfill"
}, null, -1));

const _hoisted_21 = {
  class: "loginPTwo"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_checkbox = _resolveComponent("el-checkbox");

  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Sign in')), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('Username or email address')), 1), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.username = $event),
    type: "text",
    class: "lg-input",
    id: "username"
  }, null, 512), [[_vModelText, _ctx.username]]), _hoisted_6]), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('Password')), 1), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.password = $event),
    type: "password",
    class: "lg-input",
    id: "password"
  }, null, 512), [[_vModelText, _ctx.password]]), _hoisted_9]), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('Verification')), 1), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.code = $event),
    class: "lg-input ver",
    id: "captcha"
  }, null, 512), [[_vModelText, _ctx.code]]), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = //@ts-ignore
    (...args) => _ctx.getCaptchaFn && _ctx.getCaptchaFn(...args)),
    class: "vereRight"
  }, [_createElementVNode("img", {
    id: "img110",
    style: {
      "cursor": "pointer"
    },
    src: _ctx.codeImg
  }, null, 8, _hoisted_12)])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_checkbox, {
    modelValue: _ctx.isAgree,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.isAgree = $event),
    class: _normalizeClass([_ctx.isShark ? 'my-shark' : ''])
  }, null, 8, ["modelValue", "class"]), _createElementVNode("span", _hoisted_14, [_createTextVNode(_toDisplayString(_ctx.$t('Read and know')), 1), _createElementVNode("span", {
    class: _normalizeClass(['artical']),
    onClick: _cache[5] || (_cache[5] = $event => _ctx.toPage('/agreement'))
  }, "《" + _toDisplayString(_ctx.$t('Goby user registration and service agreement')) + "》", 1)])]), _createElementVNode("button", {
    class: "login-btn",
    onClick: _cache[6] || (_cache[6] = //@ts-ignore
    (...args) => _ctx.signIn && _ctx.signIn(...args))
  }, _toDisplayString(_ctx.$t("Sign in")), 1), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.$t("Forgot password")), 1), _hoisted_18, _createElementVNode("a", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.toPage('/signUp'))
  }, _toDisplayString(_ctx.$t("Sign up")), 1)])])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("Login Success")), 1)]), _ctx.token ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("iframe", {
    src: `${_ctx.$t('host_url')}/crossLogin?token=${_ctx.token}`,
    style: {
      "display": "none"
    }
  }, null, 8, _hoisted_23)])) : _createCommentVNode("", true)]);
}